import createIcon from '../../createIcon';

/**
 * @component @name Verified
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMTJMMjAuNTYgOS4yMUwyMC45IDUuNTJMMTcuMjkgNC43TDE1LjQgMS41TDEyIDIuOTZMOC42IDEuNUw2LjcxIDQuNjlMMy4xIDUuNUwzLjQ0IDkuMkwxIDEyTDMuNDQgMTQuNzlMMy4xIDE4LjQ5TDYuNzEgMTkuMzFMOC42IDIyLjVMMTIgMjEuMDNMMTUuNCAyMi40OUwxNy4yOSAxOS4zTDIwLjkgMTguNDhMMjAuNTYgMTQuNzlMMjMgMTJaTTEwLjA5IDE2LjcyTDYuMjkgMTIuOTFMNy43NyAxMS40M0wxMC4wOSAxMy43NkwxNS45NCA3Ljg5TDE3LjQyIDkuMzdMMTAuMDkgMTYuNzJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Verified = createIcon('Verified', [
  [
    'path',
    {
      d: 'M23 12L20.56 9.21L20.9 5.52L17.29 4.7L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 12L3.44 14.79L3.1 18.49L6.71 19.31L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 12ZM10.09 16.72L6.29 12.91L7.77 11.43L10.09 13.76L15.94 7.89L17.42 9.37L10.09 16.72Z',
      key: '1r0g7f',
    },
  ],
]);

export default Verified;
